<template>
  <div class="sub_nav">
    <router-link to="/home" class="nav_button link">Home</router-link>
    <router-link to="/charge" class="nav_button link">Chargings</router-link>
    <router-link to="/projects" class="nav_button link">Projects</router-link>
    <router-link to="/profile" class="nav_button_last lnik">Profile</router-link>
  </div>
  <router-view class="app"/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 80.8px;
  width: 95vw;
  height: calc(100vh - 60px);
  background-color: aliceblue;
  overflow-x: hidden;
}

:root {
      --dp-border-radius: 10px !important;
}

body {
  display: flex;
  justify-content: center;
  overflow: hidden;
  margin: 0px;
}

.sub_nav {
  width: 95vw;
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  position: absolute;
  top: 20px;
  background: hwb(211 65% 24%);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.link.active {
  border-radius: 10px;
  background: #2c3e50;
  color: white;
}

.nav_button {
  text-decoration: none;
  border: none;
  background: none;
  align-content: center;
  width: 150px;
  height: 35px;
  margin-right: 20px;
}

.nav_button:hover {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.5);
  align-content: center;
  width: 150px;
  height: 35px;
  margin-right: 20px;
}

.nav_button_last {
  text-decoration: none;
  border: none;
  background: none;
  align-content: center;
  width: 150px;
  height: 35px;
  margin-right: 20px;
}

.nav_button_last:hover {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.5);
  align-content: center;
  width: 150px;
  height: 35px;
  margin-right: 20px;
}
</style>
